import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router,ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivityService } from './../../services/activity.service';
import {DataTableModule} from "angular-6-datatable";
import { Pipe, PipeTransform } from '@angular/core';

@Component({
  selector: 'app-show-activity',
  templateUrl: './show-activity.component.html',
  styleUrls: ['./show-activity.component.css']
})

export class ShowActivityComponent implements OnInit {
  public data: Object;
  public temp_var: Object=false;
  public user_id: any='';
  public company_id: any='';
  public APIKEY:any= '';
  public statusValue:any= '';
  public modelInfo:object=[];
  loader:boolean=false;
  public filterData : any;
  searchText:any;
  no_result:boolean=false;
  

  constructor(private _activity:ActivityService,
    private _router : Router,
    private toastr: ToastrService,
    private _activatedroute: ActivatedRoute,) { }


   
    ngOnInit() {
        this.user_id =localStorage.getItem('id');
        this.company_id =localStorage.getItem('company_id');
        this.APIKEY =localStorage.getItem('APIKEY');

        this.modelInfo= { 
          APIKEY : this.APIKEY,
          user_id : this.user_id,
          company_id : this.company_id,
          status: '',
        };

      //console.log(this.modelInfo); return false;
      this._activity.activityList(this.modelInfo)
      .subscribe(
        res => { 
        
          console.log(res);
          this.data=res;
          this.temp_var=true;
      },
      );

     
     

    }


  //   filter(id,table)
  //   {  
  //     this.loader=true;
  // const data = {
  //   id:id,
  //   user_id:localStorage.getItem('id'),
  //   role_id:localStorage.getItem('role_id'),
  //   table:table
  // } 
  // this._activity.activityList(this.modelInfo)
  //    .subscribe(
  //     res => { 
  //       if(res.data.length!=0){
  //         this.temp_var=true;
  //         this.no_result=false;
  //         this.data= res;
  //       }else
  //       {
  //       this.no_result=true;
  //       this.temp_var=false;
  //       } 
          
          
           
  //       },
  //       ); 
  
  //   }

    filter(id,table)
  {  
    this.loader=true;
const data = {
  id:id,
  user_id:localStorage.getItem('id'),
  role_id:localStorage.getItem('role_id'),
  table:table
} 
  this._activity.activityList(data)
    .subscribe(
      res => {   
        if(res.activity.length!=0)
        {
          this.no_result=false;
        this.temp_var=true;
        this.data = res;  
        }
        else
        {
        this.no_result=true;
        this.temp_var=false;
        } 
        this.loader=false;
      },
      err => {console.log(err) 
      }
  ); 

  }
}
